import { createStore } from "../../../utils/createStore.ts";

export const selectedGridAssetsUuidStore = createStore(
  {
    selectedGridAssetsUuid: [] as string[],
  },
  ({ get, set }) => ({
    addAssetUuidToSelection: (assetUuid: string) =>
      set({
        selectedGridAssetsUuid: [...get().selectedGridAssetsUuid, assetUuid],
      }),
    removeAssetUuidFromSelection: (assetUuid: string) =>
      set({
        selectedGridAssetsUuid: get().selectedGridAssetsUuid.filter(
          (uuid) => uuid !== assetUuid,
        ),
      }),
    toggleAssetUuidSelection: (assetUuid: string) => {
      if (get().selectedGridAssetsUuid.includes(assetUuid)) {
        set({
          selectedGridAssetsUuid: get().selectedGridAssetsUuid.filter(
            (uuid) => uuid !== assetUuid,
          ),
        });
      } else {
        set({
          selectedGridAssetsUuid: [...get().selectedGridAssetsUuid, assetUuid],
        });
      }
    },
    resetSelection: () =>
      set({
        selectedGridAssetsUuid: [],
      }),
  }),
);
